export const RECOMMENDATION_PREFERENCES_UPDATED_EVENT = 'recommendation-preferences-updated';

export function notifyRecommendationPreferencesUpdated() {
  window.dispatchEvent(new Event(RECOMMENDATION_PREFERENCES_UPDATED_EVENT));
}
